import React from 'react';
import cn from 'class-names';

const defaultTheme = {};
const defaultLocalTheme = {};
const defaultSpectrumOverrides = {};

const capitalize = (s) => {
  return s?.charAt(0).toUpperCase() + s.slice(1);
};

export const defaultColorSchema = undefined;
export const getLocalThemeClassName = ({ localTheme, colorScheme: currentColorScheme }) => {
  const nextCss =
    localTheme?.[currentColorScheme]?.[`local--${currentColorScheme}`] ||
    localTheme?.[currentColorScheme]?.[`local${capitalize(currentColorScheme)}`];

  const nextSizesCss = (localTheme?.globals && localTheme?.globals[`local--globals`]) || localTheme?.globals?.localGlobals;

  return localTheme && cn(nextCss, nextSizesCss);
};

export const getComponentOverrideClassName = (componentName, { spectrumOverrides, colorScheme: currentColorScheme }) => {
  const nextCss =
    spectrumOverrides?.[currentColorScheme]?.[`overrides--${componentName}`] ||
    spectrumOverrides?.[currentColorScheme]?.[`overrides${capitalize(componentName)}`];
  return spectrumOverrides && cn(nextCss);
};

export const ThemeContext = React.createContext({
  colorScheme: defaultColorSchema,
  theme: defaultTheme,
  localTheme: defaultLocalTheme,
  spectrumOverrides: defaultSpectrumOverrides,
});
